import AddressFormFieldsI18nKeys from "./form/AddressFormFields/AddressFormFields.i18n";
import ApartmentSuiteFormFieldI18nKeys from "./form/ApartmentSuiteFormField/ApartmentSuiteFormField.i18n";
import CityFormFieldI18nKeys from "./form/CityFormField/CityFormField.i18n";
import CompanyIdFormFieldI18nKeys from "./form/CompanyIdFormField/CompanyIdFormField.i18n";
import ConfirmEmailFormFieldsI18nKeys from "./form/ConfirmEmailFormFields/ConfirmEmailFormFields.i18n";
import ContactDetailsFormFieldsI18nKeys from "./form/ContactDetailsFormFields/ContactDetailsFormFields.i18n";
import ContactMethodFormFieldI18nKeys from "./form/ContactMethodFormField/ContactMethodFormField.i18n";
import CountryFormFieldI18nKeys from "./form/CountryFormField/CountryFormField.i18n";
import DateOfBirthFormFieldI18nKeys from "./form/DateOfBirthFormField/DateOfBirthFormField.i18n";
import EmailFormFieldI18nKeys from "./form/EmailFormField/EmailFormField.i18n";
import FirstNameFormFieldI18nKeys from "./form/FirstNameFormField/FirstNameFormField.i18n";
import GenderFormFieldI18nKeys from "./form/GenderFormField/GenderFormField.i18n";
import KnownTravelerNumberI18nKeys from "./form/KnownTravelerNumberFormField/KnownTravelerNumberFormField.i18n";
import LastNameFormFieldI18nKeys from "./form/LastNameFormField/LastNameFormField.i18n";
import MiddleNameFormFieldI18nKeys from "./form/MiddleNameFormField/MiddleNameFormField.i18n";
import NameFormFieldsI18nKeys from "./form/NameFormFields/NameFormFields.i18n";
import AccessibilityAccommodationsFormFieldsI18nKeys from "./form/PassengerAccommodationsFormFields/AccessibilityAccommodationsFormFields/AccessibilityAccommodationsFormFields.i18n";
import AllergiesFormFieldsI18nKeys from "./form/PassengerAccommodationsFormFields/AllergiesFormFields/AllergiesFormFields.i18n";
import AnimalAssistanceFormFieldI18nkeys from "./form/PassengerAccommodationsFormFields/AnimalAssistanceFormField/AnimalAssistanceFormField.i18n";
import MedicalEquipmentFormFieldsI18nKeys from "./form/PassengerAccommodationsFormFields/MedicalEquipmentFormFields/MedicalEquipmentFormFields.i18n";
import PassengerAccommodationsFormFieldsI18nKeys from "./form/PassengerAccommodationsFormFields/PassengerAccommodationsFormFields.i18n";
import PersonalWheelchairAssistanceFormFieldsI18nKeys from "./form/PassengerAccommodationsFormFields/PersonalWheelchairAssistanceFormFields/PersonalWheelchairAssistanceFormFields.i18n";
import WheelchairAssistanceFormFieldI18nKeys from "./form/PassengerAccommodationsFormFields/WheelchairAssistanceFormField/WheelchairAssistanceFormField.i18n";
import PhoneCountryCodeI18nKeys from "./form/PhoneCountryCodeFormField/PhoneCountryCodeFormField.i18n";
import PhoneNumberI18nKeys from "./form/PhoneNumberFormField/PhoneNumberFormField.i18n";
import PhoneTypeFormFieldI18nKeys from "./form/PhoneTypeFormField/PhoneTypeFormField.i18n";
import PreferredFirstNameFormFieldI18nKeys from "./form/PreferredFirstNameFormField/PreferredFirstNameFormField.i18n";
import RedressNumberI18nKeys from "./form/RedressNumberFormField/RedressNumberFormField.i18n";
import StateAndCountryAutocompleteI18nKeys from "./form/StateAndCountryAutocomplete/StateAndCountryAutocomplete.i18n";
import StateFormFieldI18nKeys from "./form/StateFormField/StateFormField.i18n";
import StateProvinceRegionFormFieldI18nKeys from "./form/StateProvinceRegionFormField/StateProvinceRegionFormField.i18n";
import StreetAddressFormFieldStoriesKeys from "./form/StreetAddressFormField/StreetAddressFormField.i18n";
import SuffixAutocompleteI18nKeys from "./form/SuffixAutocomplete/SuffixAutocomplete.i18n";
import SuffixFormFieldI18nKeys from "./form/SuffixFormField/SuffixFormField.i18n";
import ZipCodeFormFieldI18nKeys from "./form/ZipCodeFormField/ZipCodeFormField.i18n";

export default {
  ...AddressFormFieldsI18nKeys,
  ...AllergiesFormFieldsI18nKeys,
  ...AnimalAssistanceFormFieldI18nkeys,
  ...ApartmentSuiteFormFieldI18nKeys,
  ...AccessibilityAccommodationsFormFieldsI18nKeys,
  ...CityFormFieldI18nKeys,
  ...CompanyIdFormFieldI18nKeys,
  ...ConfirmEmailFormFieldsI18nKeys,
  ...ContactDetailsFormFieldsI18nKeys,
  ...ContactMethodFormFieldI18nKeys,
  ...CountryFormFieldI18nKeys,
  ...DateOfBirthFormFieldI18nKeys,
  ...EmailFormFieldI18nKeys,
  ...FirstNameFormFieldI18nKeys,
  ...GenderFormFieldI18nKeys,
  ...KnownTravelerNumberI18nKeys,
  ...LastNameFormFieldI18nKeys,
  ...MiddleNameFormFieldI18nKeys,
  ...NameFormFieldsI18nKeys,
  ...MedicalEquipmentFormFieldsI18nKeys,
  ...PassengerAccommodationsFormFieldsI18nKeys,
  ...PersonalWheelchairAssistanceFormFieldsI18nKeys,
  ...PhoneCountryCodeI18nKeys,
  ...PhoneNumberI18nKeys,
  ...PhoneTypeFormFieldI18nKeys,
  ...PreferredFirstNameFormFieldI18nKeys,
  ...RedressNumberI18nKeys,
  ...StateAndCountryAutocompleteI18nKeys,
  ...StateFormFieldI18nKeys,
  ...StateProvinceRegionFormFieldI18nKeys,
  ...StreetAddressFormFieldStoriesKeys,
  ...SuffixAutocompleteI18nKeys,
  ...SuffixFormFieldI18nKeys,
  ...WheelchairAssistanceFormFieldI18nKeys,
  ...ZipCodeFormFieldI18nKeys,
};
